<script setup>
import { TextField, ChoiceField } from '@haskoning/vue-component-library'
import { useCalculationStore } from '@/stores/calculation'
import { storeToRefs } from 'pinia/dist/pinia'
import { watch } from 'vue'
import { useShipStore } from '@/stores/ship'
import { useShipApiStore } from '@/stores/shipApi'
import { CONTINUOUS, HIGH_WATER, ISLAND } from '@/components/calculation/calculation.constant'
import CalculationFormIsland from '@/components/calculation-form/CalculationFormIsland.vue'
import CalculationFormContinuous from '@/components/calculation-form/CalculationFormContinuous.vue'
import {
  ACTUAL_BERTHING_ORIENTATION,
  BERTH_TYPE,
  HIGH_LOW_WATER,
  HIGH_WATER_LEVEL,
  LOW_WATER_LEVEL,
  MOORING_SIDE,
  SHIP_TYPE,
  WATER_LEVEL
} from '@/constants/calculationFieldConstants'

const { currentItem, items: calculationItems } = storeToRefs(useCalculationStore())
const { items } = storeToRefs(useShipStore())

const calculationStore = useCalculationStore()
const shipApiStore = useShipApiStore()

const { fields } = storeToRefs(calculationStore)

watch(
  () => currentItem.value[MOORING_SIDE],
  (newValue) => {
    if (newValue) {
      shipApiStore.resetState()
      shipApiStore.fetchItems()
    }
  }
)

watch(
  () => currentItem.value[SHIP_TYPE],
  (newValue) => {
    if (newValue) {
      shipApiStore.resetState()
      shipApiStore.fetchItems()
    }
  }
)

const updateHighLowWater = async () => {
  await calculationStore.update()
  const updatedCurrentItem = calculationItems.value.find((item) => item.id === currentItem.value.id)
  if (updatedCurrentItem) {
    calculationStore.setParameter(currentItem.value, WATER_LEVEL, updatedCurrentItem[WATER_LEVEL])
  }
}
</script>

<template>
  <v-list-item>
    <v-row class="mt-1">
      <v-col>
        <ChoiceField
          v-if="fields[BERTH_TYPE]"
          :item-key="BERTH_TYPE"
          :field="fields[BERTH_TYPE]"
          :model-value="currentItem"
          hide-details
          fontSize="14px"
          @update="calculationStore.update()"
        ></ChoiceField>
      </v-col>
      <v-col>
        <ChoiceField
          v-if="fields[SHIP_TYPE]"
          :disabled="items.length > 0"
          :item-key="SHIP_TYPE"
          :field="fields[SHIP_TYPE]"
          :model-value="currentItem"
          hide-details
          @update="calculationStore.update()"
        ></ChoiceField>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col>
        <TextField
          v-if="fields[ACTUAL_BERTHING_ORIENTATION]"
          :item-key="ACTUAL_BERTHING_ORIENTATION"
          :field="fields[ACTUAL_BERTHING_ORIENTATION]"
          :model-value="currentItem"
          @update="calculationStore.update()"
          fontSize="14px"
        ></TextField>
      </v-col>
      <v-col>
        <ChoiceField
          v-if="fields[MOORING_SIDE]"
          :disabled="items.length > 0"
          :item-key="MOORING_SIDE"
          :field="fields[MOORING_SIDE]"
          :model-value="currentItem"
          @update="calculationStore.update()"
        ></ChoiceField>
      </v-col>
    </v-row>
  </v-list-item>
  <v-divider></v-divider>
  <v-list-item class="pb-0 pt-4">
    <v-row>
      <v-col cols="6">
        <ChoiceField
          v-if="fields[HIGH_LOW_WATER]"
          :item-key="HIGH_LOW_WATER"
          :field="fields[HIGH_LOW_WATER]"
          :model-value="currentItem"
          @update="updateHighLowWater()"
        ></ChoiceField>
      </v-col>
      <v-col>
        <TextField
          v-if="currentItem[HIGH_LOW_WATER] === HIGH_WATER"
          :item-key="HIGH_WATER_LEVEL"
          :field="fields[HIGH_WATER_LEVEL]"
          :step="0.1"
          :model-value="currentItem"
          @update="calculationStore.update()"
        ></TextField>
        <TextField
          v-else
          :item-key="LOW_WATER_LEVEL"
          :field="fields[LOW_WATER_LEVEL]"
          :step="0.1"
          :model-value="currentItem"
          @update="calculationStore.update()"
        ></TextField>
      </v-col>
    </v-row>
  </v-list-item>
  <v-divider></v-divider>
  <CalculationFormIsland v-if="currentItem[BERTH_TYPE] === ISLAND" />
  <CalculationFormContinuous v-if="currentItem[BERTH_TYPE] === CONTINUOUS" />
</template>
